/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Driver_Next_Stop_TitleInputs */

const vi_dashboard_driver_next_stop_title = /** @type {(inputs: Dashboard_Driver_Next_Stop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điểm giao tiếp theo`)
};

/**

* @param {Dashboard_Driver_Next_Stop_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_driver_next_stop_title = /** @type {((inputs?: Dashboard_Driver_Next_Stop_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Driver_Next_Stop_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_driver_next_stop_title(inputs)
});